<template>
  <div class="container">
    <BLoading :active.sync="isLoading" />
    <div v-if="!isLoading" class="columns column-reverse">
      <div class="column is-6">
        <h1 class="has-text-weight-bold">
          Update your property.
          <span class="properties-optional-info-view--header-span"> 2 of 2</span>
        </h1>
        <form novalidate @submit.prevent="updateProperty">
          <LsRadioButtons
            v-model="info.cornerlot"
            class="properties-optional-info-view--section"
            label="Is your property located on a corner lot?"
            :options="options"
            name="cornerlot"
            track-id="properties_optional_info_view-cornerlot"
            test-id="cornerlot"
          />
          <LsRadioButtons
            v-model="info.pets"
            label="Do you have pets in your yard?"
            :options="options"
            name="pets"
            track-id="properties_optional_info_view-pets"
            test-id="pets"
          />
          <LsAdditionalInfo
            style="margin-top:0px;"
            class="properties-optional-info-view--info-dropdown"
            track-id="properties_optional_info_view-pets"
          >
            <p>
              For the safety of our crews and your pets, we will typically not be able to service
              your yard if pets are left outside.
            </p></LsAdditionalInfo
          >
          <LsRadioButtons
            v-model="info.irrigation"
            class="properties-optional-info-view--section"
            label="Do you have an irrigation system?"
            :options="options"
            name="irrigation"
            track-id="properties_optional_info_view-irrigation"
            test-id="irrigation"
          />
          <LsRadioButtons
            v-model="info.hoa"
            class="properties-optional-info-view--section"
            label="Do you live in a Homeowner's Association that enforces lawn maintenance standards?"
            :options="options"
            name="hoa"
            track-id="properties_optional_info_view-hoa"
            test-id="hoa"
          />
          <LsRadioButtons
            v-model="info.rental"
            class="properties-optional-info-view--section"
            label="Are you an owner or renter of the property?"
            :options="[{ label: 'Renter', value: true }, { label: 'Owner', value: false }]"
            name="rental"
            track-id="properties_optional_info_view-rental"
            test-id="rental"
          />
          <LsRadioButtons
            v-model="info.reside"
            class="properties-optional-info-view--section"
            label="Do you reside at the property getting service?"
            :options="options"
            name="reside"
            track-id="properties_optional_info_view-reside"
            test-id="reside"
          />
          <LsRadioButtons
            v-model="info.wants_recommendations"
            class="properties-optional-info-view--section"
            :label="
              `Are you interested in receiving service recommendations from your ${brandName} crew?`
            "
            :options="options"
            name="wants_recommendations"
            track-id="properties_optional_info_view-wants_recommendations"
            test-id="wants_recommendations"
          />
          <LsInput
            v-model="info.access_instructions"
            class="properties-optional-info-view--input "
            label="Are there any special instructions for your crew for entering either the
                        front-yard or backyard?"
            name="info.access_instructions"
            track-id="properties_optional_info_view-access_instructions"
            placeholder="Please provide details..."
            type="textarea"
          />
          <h5 class="properties-optional-info-view--h5">Do you have a grass length preference?</h5>
          <LsAdditionalInfo
            class="properties-optional-info-view--info-dropdown-input"
            track-id="properties_optional_info_view-length_preference"
          >
            <p>
              In general, our lawn care pros will use their best judgement for your lawn based upon
              their expert knowledge of grass type, mowing frequency, season, and current length of
              the grass. If you have special preference for length, please let us know!
            </p></LsAdditionalInfo
          >
          <LsRadios
            v-model="info.mowing_preferences.length_preference.front"
            class="properties-optional-info-view--input "
            :options="[
              { label: 'No Preference', value: 'none' },
              { label: 'Short', value: 'short' },
              { label: 'Medium', value: 'medium' },
              { label: 'Long', value: 'long' },
            ]"
            name="grasslength"
            track-id="properties_optional_info_view-grasslength"
          />
          <h5 class="properties-optional-info-view--h5">
            Are there any areas to lookout for when blowing clippings?
          </h5>

          <LsAdditionalInfo
            class="properties-optional-info-view--info-dropdown-input"
            track-id="properties_optional_info_view-obstruction_details"
          >
            <p>
              {{ brandName }} pros do not bag clippings, as it is much better for your lawn to leave
              lawn clippings on the lawn so it can reabsorb nutrients.
            </p>
            <p>
              As part of the basic mowing service, your crew will blow clippings off the hard
              surfaces. Sometimes there are sensitive areas of your property that require special
              attention when performing this service.
            </p>
          </LsAdditionalInfo>
          <LsInput
            v-model="info.mowing_preferences.clippings_blowing_details"
            class="properties-optional-info-view--input "
            name="clippings_blowing_details"
            track-id="properties_optional_info_view-clippings_blowing_details"
            placeholder="Please provide details..."
            type="textarea"
          />

          <h5 class="properties-optional-info-view--h5">
            Does your property have anything (besides a gate) that would prevent the use of a riding
            mower on the entire property?
          </h5>
          <LsAdditionalInfo
            class="properties-optional-info-view--info-dropdown-input"
            track-id="properties_optional_info_view-obstruction_details"
          >
            <p>
              Sometimes a property will have conditions that will prevent the use of a riding mower
              on the entire property. For example, an elevated part of the lawn or significant
              sloping of the property.
            </p></LsAdditionalInfo
          >
          <LsInput
            v-model="info.mowing_preferences.obstruction_details"
            class="properties-optional-info-view--input "
            name="obstruction_details"
            track-id="properties_optional_info_view-obstruction_details"
            placeholder="Please provide details..."
            type="textarea"
          />

          <LsInput
            v-model="info.mowing_preferences.details"
            class="properties-optional-info-view--input "
            label="Are there any other special details about the lawn mowing service that your crew should know?"
            name="details"
            track-id="properties_optional_info_view-details"
            type="textarea"
            placeholder="Please provide details..."
          />

          <LsButton
            text="Save &amp; finish"
            track-id="properties_optional_info_view-update_property"
            :loading="properties.loadingStatus.isUpdating"
            type="submit"
          />
        </form>
      </div>

      <div class="column properties-optional-info-view--address-column">
        <div class="properties-optional-info-view--address-card">
          <LsAddressCard :property="selectedProperty" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LsRadioButtons,
  LsInput,
  LsButton,
  LsAddressCard,
  LsRadios,
  LsAdditionalInfo,
} from '@/components/common';
import {
  PROPERTIES__SELECTED_PROPERTY,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
  PROPERTIES__UPDATE_PROPERTY_INFO,
} from '@/store/types';
import { mapState, mapGetters, mapActions } from 'vuex';
import { lsRouterHelpers } from 'ls-vue-common';
import _ from 'lodash';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'PropertiesOptionalInfoView',
  components: {
    LsRadioButtons,
    LsButton,
    LsAddressCard,
    LsRadios,
    LsInput,
    LsAdditionalInfo,
  },
  mixins: [themedComponentMixin],
  data() {
    return {
      property_id: lsRouterHelpers.getParam(this.$route, 'property_id'),
      options: [{ label: 'No', value: false }, { label: 'Yes', value: true }],

      info: {
        cornerlot: '',
        pets: '',
        irrigation: '',
        hoa: '',
        rental: '',
        reside: '',

        wants_recommendations: '',
        access_instructions: '',
        mowing_preferences: {
          length_preference: {
            front: '',
            back: '',
          },
          clippings_blowing_details: '',
          obstruction_details: '',
          details: '',
        },
      },
    };
  },
  computed: {
    ...mapState(['properties', 'screenSize']),
    ...mapGetters([PROPERTIES__SELECTED_PROPERTY]),
    isLoading() {
      return this.properties.loadingStatus.isLoading || _.isNil(this.selectedProperty);
    },
    selectedProperty() {
      return this[PROPERTIES__SELECTED_PROPERTY](this.property_id);
    },
  },
  async created() {
    await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();

    if (_.isNil(this.selectedProperty)) {
      return this.$router.push({
        name: 'services',
      });
    }

    this.setInitialValues();
  },
  methods: {
    ...mapActions([PROPERTIES__GET_PROPERTIES_AND_SCHEDULES, PROPERTIES__UPDATE_PROPERTY_INFO]),
    setInitialValues() {
      const propertyInfo = this.selectedProperty.info;

      this.info = {
        cornerlot: propertyInfo.cornerlot,
        pets: propertyInfo.pets,
        irrigation: propertyInfo.irrigation,
        hoa: propertyInfo.hoa,
        rental: propertyInfo.rental,
        reside: propertyInfo.reside,

        wants_recommendations: propertyInfo.wants_recommendations,
        access_instructions: _.isNull(propertyInfo.access_instructions)
          ? ''
          : propertyInfo.access_instructions,
        mowing_preferences: {
          length_preference: {
            back: _.isNull(propertyInfo.mowing_preferences.length_preference.back)
              ? 'none'
              : propertyInfo.mowing_preferences.length_preference.back,
            front: _.isNull(propertyInfo.mowing_preferences.length_preference.front)
              ? 'none'
              : propertyInfo.mowing_preferences.length_preference.front,
          },
          clippings_blowing_details: _.isNull(
            propertyInfo.mowing_preferences.clippings_blowing_details
          )
            ? ''
            : propertyInfo.mowing_preferences.clippings_blowing_details,
          obstruction_details: _.isNull(propertyInfo.mowing_preferences.obstruction_details)
            ? ''
            : propertyInfo.mowing_preferences.obstruction_details,
          details: _.isNull(propertyInfo.mowing_preferences.details)
            ? ''
            : propertyInfo.mowing_preferences.details,
        },
      };
    },
    updateProperty() {
      this.info.mowing_preferences.length_preference.back = this.info.mowing_preferences.length_preference.front;

      this[PROPERTIES__UPDATE_PROPERTY_INFO]({
        property_id: this.property_id,
        info: this.info,
        onSuccess: () => {
          this.$router.push({ name: 'services' });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.properties-optional-info-view--section {
  margin: 10px 0px;
  padding: 10px 0px;
  border-bottom: 1px solid $primary-light;
}
.properties-optional-info-view--input {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid $primary-light;
}
.properties-optional-info-view--header-span {
  font-weight: normal;
  font-size: $size-1;
}
.properties-optional-info-view--address-column {
  @media (min-width: $desktop) {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }
  @media (max-width: $mobile-max-width) {
    padding-bottom: 15px;
    border-bottom: 1px solid $primary-light;
  }
}
.column-reverse {
  @media (max-width: $mobile-max-width) {
    display: flex;
    flex-direction: column-reverse;
  }
}
.properties-optional-info-view--info-dropdown {
  margin-top: -10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $primary-light;
  font-style: italic;
}
.properties-optional-info-view--h5 {
  font-size: $size-5;
  font-weight: 600;
  margin-bottom: 5px;
}
.properties-optional-info-view--info-dropdown-input {
  margin-bottom: 10px;
  font-style: italic;
}
.themed-app {
  .properties-optional-info-view--section {
    border-color: $theme-color-primary-light;
  }
  .properties-optional-info-view--input {
    border-color: $theme-color-primary-light;
  }
  .properties-optional-info-view--header-span {
    font-size: $theme-txt-headline;
  }
  .properties-optional-info-view--address-column {
    @media (max-width: $mobile-max-width) {
      border-color: $theme-color-primary-light;
    }
  }
  .properties-optional-info-view--info-dropdown {
    border-color: $theme-color-primary-light;
  }
  .properties-optional-info-view--h5 {
    font-size: $theme-txt-body;
  }
}
</style>
